module.exports = __webpack_public_path__ + "static/media/projects_image.4f4971a7.svg";